import * as React from "react";

function ModalHeader2({ label, otherLabel }: { label: string; otherLabel?: string }) {
  return (
    <div>
      <h4
        className="modal-header-dark text-center text-50 padding-top-m is-white"
        id="myModalLabel"
      >
        {label}
      </h4>

      {otherLabel && (
        <h4
          className="modal-header-dark text-center text-50 padding-top-m is-white"
          id="myModalLabel"
        >
          {otherLabel}
        </h4>
      )}
    </div>
  );
}

export default ModalHeader2;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/modal/ModalHeader2.primitive.tsx